import instance from '@apis/instance';
import {
    BioDeviceResponse,
    KiccCardsResponse, KiccPaymentRequest,
    RegisterKiccCardRequest,
    RegisterKiccCardResponse,
    RegisterKiccPinRequest, ResetPinRequest, SetBioDeviceRequest,
    UpdateKiccCardNameRequest,
} from '@models/easyCard/kicc';

class KiccEasyCardApi {
    static registerCard(request: RegisterKiccCardRequest): Promise<RegisterKiccCardResponse> {
        return instance.post('/v0/easy-card/kicc/cards/registration', request);
    }

    static getCards(): Promise<KiccCardsResponse> {
        return instance.get('/v0/easy-card/kicc/cards');
    }

    static updateCardName(cardId: string, request: UpdateKiccCardNameRequest) {
        return instance.patch(`/v0/easy-card/kicc/cards/${cardId}`, request);
    }

    static deleteCard(cardId: string): Promise<never> {
        return instance.delete(`/v0/easy-card/kicc/cards/${cardId}`);
    }

    static registerPin(request: RegisterKiccPinRequest): Promise<never> {
        return instance.put('/v0/easy-card/kicc/pin', request);
    }

    static payment(request: KiccPaymentRequest): Promise<never> {
        return instance.post('/v0/order/payment/kicc-billing-key', request);
    }

    static getIsBioDevice(deviceId: string): Promise<BioDeviceResponse> {
        return instance.get('/v0/easy-card/kicc/pin/bio-device', { params: { deviceId } });
    }

    static setBioDevice(request: SetBioDeviceRequest): Promise<never> {
        return instance.put('/v0/easy-card/kicc/pin/bio-device', request);
    }

    static deleteBioDevice(deviceId: string): Promise<never> {
        return instance.delete('/v0/easy-card/kicc/pin/bio-device', { params: { deviceId } });
    }

    static resetPin(request: ResetPinRequest): Promise<never> {
        return instance.post('/v0/easy-card/kicc/pin/reset', request);
    }
}

export default KiccEasyCardApi;
